export const gnmWmm2020 = [
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [-29404.5, -1450.7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [-2500, 2982, 1676.8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [1363.9, -2381, 1236.2, 525.7, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [903.1, 809.4, 86.2, -309.4, 47.9, 0, 0, 0, 0, 0, 0, 0, 0],
    [-234.4, 363.1, 187.8, -140.7, -151.2, 13.7, 0, 0, 0, 0, 0, 0, 0],
    [65.9, 65.6, 73, -121.5, -36.2, 13.5, -64.7, 0, 0, 0, 0, 0, 0],
    [80.6, -76.8, -8.3, 56.5, 15.8, 6.4, -7.2, 9.8, 0, 0, 0, 0, 0],
    [23.6, 9.8, -17.5, -0.4, -21.1, 15.3, 13.7, -16.5, -0.3, 0, 0, 0, 0],
    [5, 8.2, 2.9, -1.4, -1.1, -13.3, 1.1, 8.9, -9.3, -11.9, 0, 0, 0],
    [-1.9, -6.2, -0.1, 1.7, -0.9, 0.6, -0.9, 1.9, 1.4, -2.4, -3.9, 0, 0],
    [3, -1.4, -2.5, 2.4, -0.9, 0.3, -0.7, -0.1, 1.4, -0.6, 0.2, 3.1, 0],
    [-2, -0.1, 0.5, 1.3, -1.2, 0.7, 0.3, 0.5, -0.2, -0.5, 0.1, -1.1, -0.3],
];

export const hnmWmm2020 = [
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 4652.9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, -2991.6, -734.8, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, -82.2, 241.8, -542.9, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 282, -158.4, 199.8, -350.1, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 47.7, 208.4, -121.3, 32.2, 99.1, 0, 0, 0, 0, 0, 0, 0],
    [0, -19.1, 25, 52.7, -64.4, 9, 68.1, 0, 0, 0, 0, 0, 0],
    [0, -51.4, -16.8, 2.3, 23.5, -2.2, -27.2, -1.9, 0, 0, 0, 0, 0],
    [0, 8.4, -15.3, 12.8, -11.8, 14.9, 3.6, -6.9, 2.8, 0, 0, 0, 0],
    [0, -23.3, 11.1, 9.8, -5.1, -6.2, 7.8, 0.4, -1.5, 9.7, 0, 0, 0],
    [0, 3.4, -0.2, 3.5, 4.8, -8.6, -0.1, -4.2, -3.4, -0.1, -8.8, 0, 0],
    [0, 0, 2.6, -0.5, -0.4, 0.6, -0.2, -1.7, -1.6, -3, -2, -2.6, 0],
    [0, -1.2, 0.5, 1.3, -1.8, 0.1, 0.7, -0.1, 0.6, 0.2, -0.9, 0, 0.5],
];

export const gtnmWmm2020 = [
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [6.7, 7.7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [-11.5, -7.1, -2.2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [2.8, -6.2, 3.4, -12.2, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [-1.1, -1.6, -6, 5.4, -5.5, 0, 0, 0, 0, 0, 0, 0, 0],
    [-0.3, 0.6, -0.7, 0.1, 1.2, 1, 0, 0, 0, 0, 0, 0, 0],
    [-0.6, -0.4, 0.5, 1.4, -1.4, 0, 0.8, 0, 0, 0, 0, 0, 0],
    [-0.1, -0.3, -0.1, 0.7, 0.2, -0.5, -0.8, 1, 0, 0, 0, 0, 0],
    [-0.1, 0.1, -0.1, 0.5, -0.1, 0.4, 0.5, 0, 0.4, 0, 0, 0, 0],
    [-0.1, -0.2, 0, 0.4, -0.3, 0, 0.3, 0, 0, -0.4, 0, 0, 0],
    [0, 0, 0, 0.2, -0.1, -0.2, 0, -0.1, -0.2, -0.1, 0, 0, 0],
    [0, -0.1, 0, 0, 0, -0.1, 0, 0, -0.1, -0.1, -0.1, -0.1, 0],
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, -0.1],
];

export const htnmWmm2020 = [
    [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, -25.1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, -30.2, -23.9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 5.7, -1, 1.1, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0.2, 6.9, 3.7, -5.6, 0, 0, 0, 0, 0, 0, 0, 0],
    [0, 0.1, 2.5, -0.9, 3, 0.5, 0, 0, 0, 0, 0, 0, 0],
    [0, 0.1, -1.8, -1.4, 0.9, 0.1, 1, 0, 0, 0, 0, 0, 0],
    [0, 0.5, 0.6, -0.7, -0.2, -1.2, 0.2, 0.3, 0, 0, 0, 0, 0],
    [0, -0.3, 0.7, -0.2, 0.5, -0.3, -0.5, 0.4, 0.1, 0, 0, 0, 0],
    [0, -0.3, 0.2, -0.4, 0.4, 0.1, 0, -0.2, 0.5, 0.2, 0, 0, 0],
    [0, 0, 0.1, -0.3, 0.1, -0.2, 0.1, 0, -0.1, 0.2, 0, 0, 0],
    [0, 0, 0.1, 0, 0.2, 0, 0, 0.1, 0, -0.1, 0, 0, 0],
    [0, 0, 0, -0.1, 0.1, 0, 0, 0, 0.1, 0, 0, 0, -0.1],
];

export const globe = {
    a: 6378.137,
    b: 6356.7523142,
    r0: 6371.2,
};
